// extracted by mini-css-extract-plugin
export default {"modalContainer":"ModalDestinationSchema_modalContainer__3y7kg","table_invisible":"ModalDestinationSchema_table_invisible__2O4w2"};